import {ListFilterButton} from '@github-ui/list-filter-button'
import {ActionList, ActionMenu, VisuallyHidden} from '@primer/react'
import {useState} from 'react'

import {getProjectSortOption, PROJECT_SORT_OPTIONS, type ProjectSortValue} from './project-sort-options'

interface ProjectSortMenuProps {
  sort: ProjectSortValue
  onSortChange: (value: ProjectSortValue) => void
}

export function ProjectSortMenu({sort, onSortChange}: ProjectSortMenuProps) {
  const [open, setOpen] = useState(false)
  const selected = getProjectSortOption(sort)

  return (
    <ActionMenu open={open} onOpenChange={setOpen}>
      <ActionMenu.Anchor>
        <ListFilterButton aria-expanded={open} aria-haspopup="menu">
          Sort
          <VisuallyHidden>: {selected.label}</VisuallyHidden>
        </ListFilterButton>
      </ActionMenu.Anchor>
      <ActionMenu.Overlay align="end">
        <ActionList selectionVariant="single" aria-label="Sort projects by">
          {PROJECT_SORT_OPTIONS.map(option => (
            <ActionList.Item
              key={option.value}
              selected={option.value === sort}
              onSelect={() => onSortChange(option.value)}
            >
              {option.label}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
